import React, { Component } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
class TotaalPunten extends Component {
    componentWillMount() {


    }
    render() {
        let data = this.props.data
        return (
            <div className="rapport">
                <Row>
                    <Col sm={12}>
                        <h5><strong>Totaal aantal punten</strong></h5>
                    </Col>
                    <Col sm={6}>
                        <Table responsive bordered className="totaalPunten">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>eenheden</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Kennis</td>
                                    <td>{data ? data.knowledge : null}</td>
                                </tr>
                                <tr>
                                    <td>Werkervaring</td>
                                    <td>{data ? data.workingExperience : null}</td>
                                </tr>
                                <tr>
                                    <td>Gemiddeld aantal gewerkte uren per jaar</td>
                                    <td>{data ? data.averageHours : null}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                    <Col sm={6}>
                        <Table responsive bordered className="totaalPunten">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>eenheden</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Permanente educatie</td>
                                    <td>{data ? data.permanentEducation : null}</td>
                                </tr>
                                <tr>
                                    <td>Doorlopende werkervaring (voor doorgroei naar RO)</td>
                                    <td>{data ? data.continuousWorkExperience : null}</td>
                                </tr>
                                <tr>
                                    <td>Gemiddeld aantal gewerkte uren per jaar (doorlopende werkervaring)</td>
                                    <td>{data ? data.continuousWorkExperienceAverageHours : null}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default TotaalPunten;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/TotaalPunten.js